<template>
  <v-layout row wrap>
    <v-flex md8>
      <v-card>
        <div :id="graphicId" class="funnel-graphic py-4"></div>
      </v-card>
    </v-flex>
    <v-flex md4 pl-3>
      <vue-perfect-scrollbar class="elevation-2 white" :settings="scrollbarSettings">
        <v-list class="negative-statuses-list pa-0">
          <template v-if="negativeStatuses.length">
            <template v-for="(status, i) in negativeStatuses">
              <v-divider v-if="i"></v-divider>
              <v-list-tile>
                <v-list-tile-content>
                  <v-layout justify-center align-center class="w-100">
                    <v-flex md1 class="mr-4">
                      <v-icon>
                        fa-{{ icons[status.name.toLowerCase().replace(/ /g,'_')] }}
                      </v-icon>
                    </v-flex>
                    <v-flex md7 pl-2>
                      <p class="f0-9em d-inline text-medium-light">
                        {{ status.name }}
                      </p>
                    </v-flex>
                    <v-flex md4 pl-3 text-xs-center>
                      <p class="f0-9em d-inline text-medium-light">
                        {{ status.amount }}
                      </p>
                    </v-flex>
                  </v-layout>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </template>
          <v-list-tile v-else>
            <v-list-tile-content>
              <v-layout justify-center align-center class="w-100 mt-2">
                <v-flex md12 class="mr-4 text-xs-center">
                  <v-icon>
                    fas fa-info-circle
                  </v-icon>
                  <p class="f0-9em d-inline text-medium-light ml-3">
                    No hay nada que mostrar
                  </p>
                </v-flex>
              </v-layout>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </vue-perfect-scrollbar>
    </v-flex>
  </v-layout>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Chartist from 'chartist';
import ctBarLabelsMixin from '@/mixins/ctBarLabels';
import EventBus from '@/event-bus';

const qs = require('qs');

window.Chartist = Chartist;

require('@/assets/js/ctBarLabels.js');

export default {
  props: {
    graphicId: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
    searchOnCreate: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  mixins: [
    ctBarLabelsMixin,
  ],
  created() {
    EventBus.$on(`${this.graphicId}Reload`, () => {
      this.searchData();
    });
    EventBus.$on(`${this.graphicId}Rebuild`, () => {
      this.buildGraphic();
    });
    if (this.searchOnCreate) {
      this.searchData();
    }
  },
  destroyed() {
    EventBus.$off(`${this.graphicId}Reload`);
    EventBus.$off(`${this.graphicId}Rebuild`);
  },
  data() {
    return {
      series: [],
      negativeStatuses: [],
      icons: {
        invalido: 'shield-alt',
        marcado_spam: 'user-astronaut',
        rebotado: 'backward',
        equivocado: 'user-times',
        no_enviado: 'comment-slash',
        no_entregado: 'calendar-times',
        ocupado: 'user-clock',
        error: 'times-circle',
        no_contesta: 'phone-slash',
        buzon_de_voz: 'headset',
        rechazado: 'user-alt-slash',
        sin_compromiso: 'calendar-times',
      },
      scrollbarSettings: {
        minScrollbarLength: 160,
        maxScrollbarLength: 320,
        wheelSpeed: 2,
      },
    };
  },
  methods: {
    searchData() {
      this.axios.get(`${this.url}?${qs.stringify(this.filters)}`).then((response) => {
        this.series = Array.from(Object.values(response.data.data));
        this.negativeStatuses = response.data.negative_statuses;
        this.buildGraphic();
      }).catch(() => {});
    },
    buildGraphic() {
      const maxValue = this.graphicMaxValue(this.series);
      new Chartist.Bar(`#${this.graphicId}`, { // eslint-disable-line
        labels: this.labels,
        series: this.series,
      }, {
        distributeSeries: true,
        height: '55vh',
        plugins: [
          Chartist.plugins.ctBarLabels(),
        ],
        axisY: {
          type: Chartist.FixedScaleAxis,
          high: maxValue + this.graphicScale(maxValue),
          ticks: this.graphicTicks(maxValue),
          offset: 0,
        },
        axisX: {
          offset: 40,
        },
      });
    },
  },
  watch: {
    series(newVal) {
      EventBus.$emit(`${this.graphicId}Series`, newVal);
    },
  },
};
</script>

<style scoped>
.negative-statuses-list {
  height: 60vh;
}

.funnel-graphic {
  height: 60vh;
}
</style>


// WEBPACK FOOTER //
// src/components/panel/management/FunnelGraphic.vue